module.exports = __webpack_public_path__ + "img/barracks_small.11f50a94.png";